import {Button} from '@dropbox/dig-components/buttons';
import type {ComponentProps} from 'react';

import styles from './CancelButton.module.css';

type CancelButtonProps = Omit<ComponentProps<typeof Button>, 'variant'>;

export const CancelButton = ({children = 'Cancel', className, ...props}: CancelButtonProps) => {
  const combinedClassName = className ? `${styles.cancelButton} ${className}` : styles.cancelButton;

  return (
    <Button variant="opacity" className={combinedClassName} {...props}>
      {children}
    </Button>
  );
};
